

























import { Component, Vue, Prop } from 'vue-property-decorator'
import config from '@/config'
import { Discount, DiscountOp } from '@/store/types'

@Component({})
export default class DeliveryItem extends Vue {
	@Prop({ type: Number }) price100!: number
	@Prop() readonly discount!: Discount

	private readonly currency = config.currency

	private get isDiscount(): boolean {
		return new DiscountOp(this.discount).isDiscountForDelivery()
	}

	private get deliveryPriceOriginal100(): number {
		return this.price100
	}

	private get deliveryPriceCurrent100(): number {
		return new DiscountOp(this.discount).computeDeliveryPrice(this.price100)
	}
}
